import React from 'react';

const PreLoading = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 border-4 border-[#1a9588] border-t-transparent rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-3 h-3 bg-[#1a9588] rounded-full animate-ping"></div>
        </div>
      </div>
      <p className="mt-4 text-lg font-medium text-gray-700 animate-pulse">please wait...</p>
    </div>
  );
};

export default PreLoading;
